import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC040106_01,
    explanatoryTextRule: "\\n",
  },
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
    showLine: false,
  },
  {
    keyword: "title1",
    type: "lineTitle",
    lineTitle: "法人情報",
  },
  {
    title: "経営者種別",
    keyword: "businessOwnerClass",
    type: "text",
  },
  {
    title: "法人名（ｶﾅ）  ",
    keyword: "corpNameKana",
    type: "text",
  },
  {
    title: "法人名",
    keyword: "corpName",
    type: "text",
  },
  {
    title: "代表者職名",
    keyword: "directorTitle",
    type: "label",
    inputProps: { maxLength: 85 },
  },
  {
    title: "代表者氏名",
    keyword: "directorName",
    type: "name",
  },
  {
    title: "郵便番号",
    keyword: "zipcode",
    type: "text",
  },
  {
    title: "所在地",
    keyword: "address",
    disabled: true,
    valueObject: {
      prefectures: "",
      city: "",
      address: "",
    },
    type: "locationGroup",
  },
  {
    title: "法人番号",
    keyword: "corpNumber",
    type: "text",
  },
  {
    title: "代表電話番号",
    keyword: "tel",
    type: "text",
  },
  {
    title: "代表FAX番号",
    keyword: "fax",
    type: "text",
  },
  {
    keyword: "title2",
    type: "lineTitle",
    lineTitle: "担当者情報",
  },
  {
    title: "所属部署名",
    keyword: "deptName",
    type: "label",
    inputProps: { maxLength: 85 },
  },
  {
    title: "役職",
    keyword: "position",
    type: "label",
    inputProps: { maxLength: 85 },
  },
  {
    title: "氏名",
    keyword: "name",
    type: "name",
    requiredIcon: true,
  },
  {
    title: "電話番号",
    keyword: "contactTel",
    type: "phoneNum",
    maxLength: 20,
    requiredIcon: true,
  },
  {
    keyword: "title3",
    type: "lineTitle",
    lineTitle: "連絡先メールアドレス",
    requiredIcon: true,
  },
  {
    title: "メールアドレス",
    keyword: "contactEmail",
    type: "mail",
    requiredIcon: true,
    inputProps: { maxLength: 255 },
  },
];

const schema = {
  directorTitle: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  directorName: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 20,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "20"),
    },
  },
  deptName: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  position: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  name: {
    required: {
      value: true,
      message: TkPropertyMessageGet("TKMSG_SCR0043E"),
    },
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  contactTel: {
    required: {
      value: true,
      message: TkPropertyMessageGet("TKMSG_SCR0043E"),
    },
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 20,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "20"),
    },
  },
  contactEmail: {
    required: {
      value: true,
      message: TkPropertyMessageGet("TKMSG_SCR0043E"),
    },
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 255,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "255"),
    },
  },
};

export { fakeTableList, schema };
